export default "__VITE_ASSET__BlKxU3Cv__"